<template>
  <BModal
    ref="modal"
    size="lg"
    :title="$gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_title')"
    :ok-only="true"
    :ok-title="$gadTranslateUpper('general_ok')"
    :lazy="true"
  >
    <div>
      <Firework />
      <TextOnLine
        class="mb-4 mt-4"
      >
        {{ $gadTranslateUpper('general_step_one') }}
      </TextOnLine>
      <div class="flex-container">
        <div class="title-and-info">
          <h6>{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_one_title') }}</h6>
          <p class="mb-1">{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_one_text') }}</p>
        </div>
        <div class="action text-center mt-2 mb-3">
          <ActionBar
            :image-path="returnOneDayVacancyBanner"
            :image-updated="oneDayVacancy.updated"
            :title-to-share="oneDayVacancy.name"
            :subtitle-one="organisationInfo?.name"
            :subtitle-two="formatAddressStreet(oneDayVacancy.address) + ' ' + formatAddressMunicipality(oneDayVacancy.address)"
            :show-like-button="false"
          />
        </div>
      </div>
      <TextOnLine
        class="mb-4 mt-4"
      >
        {{ $gadTranslateUpper('general_step_two') }}
      </TextOnLine>
      <div class="flex-container">
        <div class="title-and-info">
          <h6 class="mt-2">{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_two_title') }}</h6>
          <p>{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_two_text') }}</p>
        </div>
        <div class="action text-center mt-2 mb-3">
          <a @click="copyOneDayVacancyLink">{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_two_btn_text') }}</a>
        </div>
      </div>
      <TextOnLine
        class="mb-4 mt-4"
      >
        {{ $gadTranslateUpper('general_step_three') }}
      </TextOnLine>
      <div class="flex-container">
        <div class="title-and-info">
          <h6 class="mt-2">{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_three_title') }}</h6>
          <p>{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_three_text') }}</p>
        </div>
        <div class="action text-center mt-2 mb-3">
          <a @click="printOneDayVacancy">{{ $gadTranslateUpper('create_edit_one_day_vacancy_publish_modal_step_three_btn_text') }}</a>
        </div>
      </div>
    </div>
  </BModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { oneDayVacancyBannerImage } from 'give-a-day-shared/utils/s3Path.mjs'
import { formatAddressMunicipality, formatAddressStreet } from 'give-a-day-shared/utils/addressUtils.mjs'
import { waitForRef } from '@/functions/waitUntilRefReady.js'

const emit = defineEmits(['copy-one-day-vacancy-link', 'print-one-day-vacancy'])
const modal = ref(null)

const props = defineProps({
  oneDayVacancy: { type: Object, required: true },
  organisationInfo: { type: Object, required: true },
})

const show = async () => {
  const publishModal = await waitForRef(modal)
  publishModal.show()
}

const copyOneDayVacancyLink = () => {
  emit('copy-one-day-vacancy-link')
}

const printOneDayVacancy = () => {
  emit('print-one-day-vacancy')
}

const returnOneDayVacancyBanner = computed(() => {
  let path = oneDayVacancyBannerImage(props.oneDayVacancy.organisationId, props.oneDayVacancy.id)

  return path
})

defineExpose({
  show,
})

</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .title-and-info {
    display: flex;
    flex-direction: column;
  }

  .action {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
  }
}
</style>
